export default __webpack_public_path__ + "static/media/Convention_Center_title_normal.22193ce4.svg";